module.exports = __webpack_public_path__ + "stylesheets/tabs_b83b28e6c81fd21cf877255ffae3c5f8.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/tabs.less
// module id = 4eYb
// module chunks = 118